module.exports = __webpack_public_path__ + "img/appPrizeTitleImg.a2aa61fd.png";